<template>
  <div class="game-list">
    <div v-for="game in games" class="game-list-row">
      <router-link v-bind:to="'/play/' + game.name">
          <img class="gameicon" :src="'assets/gameicon/' + game.name + '_gameicon.png'"/>
          <h3 class="title">{{game.title}}</h3>
          <div class="description">{{game.description}}</div>
      </router-link>
    </div>
  </div>
</template>

<script>

import { games } from '../games';

export default {
  name: 'list-games',
  data () {
    return {
      games
    }
  },
  created: function() {
    console.log('home created');
    // ...
  }
}
</script>

<style scope>
.gameicon {
  height: 100px;
  float: left;
  margin-right: 10px;
}
.title {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.6rem;
}
.descrition {
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.game-list-row {
  margin: 10px 0;
}
.game-list-row a, .game-list-row a:hover {
  color: #212525;
  text-decoration: none;
}
.game-list-row:after {
    content: '';
    display: block;
    clear: both;
}

</style>



// WEBPACK FOOTER //
// ListGames.vue?2a483253